import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { ServerValidationError } from '@/api/shared/types'
import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { ParkingService } from '../lib/parking.service'
import { BookedSlot, TariffType } from '../lib/parking.types'

const GET_PARKING_SLOTS = 'get-parking-slots'

type Props = {
  type: TariffType
  from: string
  to: string
  autoNumber?: string
  isStandard?: boolean
  personalAccountId?: string
  enabled?: boolean
}

export const useParkingSlots = ({
  type,
  from,
  to,
  autoNumber,
  isStandard,
  personalAccountId,
  enabled = true
}: Props) => {
  const { selectedProjectId: projectId } = useSelectedProjectStore()

  const { data, isLoading, isFetching, error, refetch } = useQuery<
    { data: BookedSlot[] },
    AxiosError<ServerValidationError>,
    BookedSlot[]
  >({
    queryKey: [
      GET_PARKING_SLOTS,
      projectId,
      type,
      from,
      to,
      autoNumber,
      isStandard,
      personalAccountId
    ],
    queryFn: () =>
      ParkingService.getParkingSlots(
        projectId,
        type,
        from,
        to,
        autoNumber,
        isStandard,
        personalAccountId
      ),
    select: response => response.data,
    staleTime: 0,
    enabled: Boolean(projectId) && enabled
  })

  return {
    data: data ?? [],
    isLoading,
    isFetching,
    error,
    refetch
  }
}
